import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { compose, hoistStatics, withState, lifecycle, withHandlers, withProps } from 'recompose';
import Invoices from './Invoices';
import StripeInvoicesService from '../../../services/stripeInvoices.service.js';
import ModuleService from '../../../services/module.service';
import { settingsActions } from '../../../reducers/settings';

const mapStateToProps = state => ({
  modulesSettings: state.modules.modulesSettings,
});

const mapDispatchToProps = {
  updateSettings: settingsActions.updateSettings,
};

const getInvoicesList = async props => {
  const { lastInvoiceId, setLastInvoiceId, setInvoices, invoices, setHasMore, setIsLoading, updateSettings } = props;
  updateSettings({ hasLoadedPage: false });
  const resp = await StripeInvoicesService.getList({ lastInvoiceId: lastInvoiceId || undefined  });

  setHasMore(resp.has_more);
  setInvoices([...invoices, ...resp.data]);
  setLastInvoiceId(resp.data.length ? resp.data[resp.data.length - 1].id : false);

  setIsLoading(false);
  updateSettings({ hasLoadedPage: true });
};

const enhance = compose(
  translate('portal'),
  connect(mapStateToProps, mapDispatchToProps),
  withState('isLoading', 'setIsLoading', true),
  withState('invoices', 'setInvoices', []),
  withState('lastInvoiceId', 'setLastInvoiceId', false),
  withState('hasMore', 'setHasMore', false),
  withProps(props => ({
    backgroundColor:
    (props.page && props.page.color) || (props.modulesSettings[ModuleService.TYPE_STRIPE_INVOICES].color ?
      props.modulesSettings[ModuleService.TYPE_STRIPE_INVOICES].color
      : props.modulesSettings[ModuleService.TYPE_STRIPE_INVOICES].default_color),
    backgroundCover: (props.page && props.page.cover && props.page.cover.id)
    || props.modulesSettings[ModuleService.TYPE_STRIPE_INVOICES].cover,
    enableCoverColor: props.page && props.page.enable_cover_color,
  })),
  lifecycle({
    async componentDidMount() {
      await getInvoicesList(this.props)
    },
  }),
  withHandlers({
    onShowMore: props => event => {
      event.preventDefault();
      getInvoicesList(props);
    },
  }),
);

export default hoistStatics(enhance)(Invoices);



// WEBPACK FOOTER //
// ./src/views/modules/stripeInvoices/index.js